import createClient, { type Middleware } from 'openapi-fetch';
import type { paths } from './schema';
import { apiUrl } from './client';
import { getDistributorToken, redirectToManage } from '../auth/useDistributorAuth';

/**
 * Create an openapi-fetch client that uses the distributor JWT from localStorage.
 * On 401 responses, clears auth and redirects to manage.realtimefeedback.com.
 */
function createDistributorClient() {
  const client = createClient<paths>({ baseUrl: apiUrl });

  const authMiddleware: Middleware = {
    async onRequest({ request }) {
      const token = getDistributorToken();
      if (token) {
        request.headers.set('Authorization', `Bearer ${token}`);
      }
      return request;
    },
    async onResponse({ response }) {
      if (response.status === 401) {
        redirectToManage();
      }
      return response;
    },
  };

  client.use(authMiddleware);
  return client;
}

let _client: ReturnType<typeof createClient<paths>> | null = null;

export function getDistributorClient() {
  if (!_client) {
    _client = createDistributorClient();
  }
  return _client;
}
